import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { endpoints } from '../api/api';
import '../styles/QuestionsSection.css';

const QuestionsSection = () => {
  const { t } = useTranslation();
  const [question, setQuestion] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 清除之前的消息
    setMessage('');
    setError('');
    
    // 验证输入
    if (!question.trim()) {
      setError('Please enter your question');
      return;
    }
    
    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }
    
    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const response = await endpoints.questions.create({
        email: email.trim(),
        content: question.trim(),
        name: name.trim() || undefined
      });
      
      if (response.data.success) {
        setMessage(response.data.message || 'Thank you for your question! We will reply to you as soon as possible.');
        setQuestion('');
        setEmail('');
        setName('');
      }
    } catch (err) {
      console.error('Submit question failed:', err);
      setError(err.response?.data?.message || 'Submit failed, please try again later');
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <section className="questions-section">
      <div className="questions-container">
        <h2 className="questions-title">Questions</h2>
        
        <p className="questions-subtitle">
          {t('questions.anythingElse')}
        </p>
        
        <div className="questions-form-container">
          <p className="questions-prompt-left">{t('questions.leaveQuestions')}</p>
          
          <form onSubmit={handleSubmit} className="questions-form">
            <input 
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your name (optional)"
              className="questions-input name-input"
            />
            <input 
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email *"
              className="questions-input email-input"
              required
            />
            <textarea 
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              placeholder="Type your question here... *"
              className="questions-input question-textarea"
              required
              rows={3}
            />
            <button 
              type="submit" 
              className="questions-submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </form>
          
          {message && <div className="questions-success-message">{message}</div>}
          {error && <div className="questions-error-message">{error}</div>}
        </div>
      </div>
    </section>
  );
};

export default QuestionsSection; 